import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import useISPowner from "../../../hooks/useISPOwner";
import Sidebar from "../../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../../assets/js/theme";
import Loader from "../../../components/common/Loader";
import {
  ArchiveFill,
  ArrowClockwise,
  GraphUpArrow,
  PenFill,
  PersonPlusFill,
  Receipt,
  ThreeDots,
} from "react-bootstrap-icons";
import Table from "../../../components/table/Table";
import Footer from "../../../components/admin/footer/Footer";
import ResellerDialog from "./ResellerDialog";
import {
  deleteBandwidthReseller,
  getBandwidthPackageByISPOwner,
  getBandwidthResellerByISPOwner,
} from "../../../features/apiCallReseller";
import { badge } from "../../../components/common/Utils";
import ResellerInvoice from "./ResellerInvoice";
import moment from "moment";

const BandwidthReseller = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  //---> Get ispOwner bandwidth packages form redux store
  const packages = useSelector((state) => state?.reseller?.bandwidthPackage);

  //---> Get ispOwner bandwidth packages form redux store
  const resellers = useSelector((state) => state?.reseller?.bandwidthReseller);

  //---> Local State
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resellerInfo, setResellerInfo] = useState({});
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [reseller, setReseller] = useState({});

  useEffect(() => {
    !packages?.length &&
      getBandwidthPackageByISPOwner(dispatch, ispOwnerId, setIsLoading);

    !resellers?.length &&
      getBandwidthResellerByISPOwner(dispatch, ispOwnerId, setIsLoading);
  }, []);

  const reloadHandler = () => {
    getBandwidthResellerByISPOwner(dispatch, ispOwnerId, setIsLoading);
  };

  const handleDeleteBandwidthReseller = (id) => {
    let confirm = window.confirm(t("deleteBandwidthReseller"));

    if (confirm) {
      deleteBandwidthReseller(dispatch, id, setLoading);
    }
  };

  // table column
  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "12%",
        Header: t("name"),
        accessor: "name",
      },
      {
        width: "10%",
        Header: t("mobile"),
        accessor: "mobile",
      },
      {
        width: "10%",
        Header: t("address"),
        accessor: "address",
      },
      {
        width: "10%",
        Header: t("due"),
        accessor: "due",
      },
      {
        width: "10%",
        Header: t("status"),
        accessor: "status",
        Cell: ({ cell: { value } }) => badge(value),
      },
      {
        width: "10%",
        Header: t("date"),
        accessor: "activationDate",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("YYYY/MM/DD hh:mm A");
        },
      },
      {
        width: "7%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",

        Cell: ({ row: { original } }) => (
          <div className="d-flex justify-content-center align-items-center">
            <div className="dropdown">
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="resellerDropdown">
                <li
                  onClick={() => {
                    setReseller(original);
                    setModalStatus("reseller");
                    setShow(true);
                    setIsUpdate(true);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">{t("edit")}</p>
                    </div>
                  </div>
                </li>

                <li
                  onClick={() => {
                    setModalStatus("invoice");
                    setShow(true);
                    setResellerInfo(original);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <Receipt />
                      <p className="actionP">{t("invoice")}</p>
                    </div>
                  </div>
                </li>

                {/* <li>
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <GraphUpArrow />
                      <p className="actionP">{t("collection")}</p>
                    </div>
                  </div>
                </li> */}

                <li
                  onClick={() => handleDeleteBandwidthReseller(original?._id)}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <ArchiveFill />
                      <p className="actionP">{t("delete")}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ),
      },
    ],
    [t]
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>{t("bandwidthReseller")}</div>
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div>

                    <div
                      title={t("reseller")}
                      onClick={() => {
                        setModalStatus("reseller");
                        setShow(true);
                      }}
                    >
                      <PersonPlusFill className="addcutmButton" />
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="collectorWrapper mt-2 py-1">
                  <div className="table-section">
                    <Table
                      isLoading={isLoading}
                      columns={columns}
                      data={resellers}
                    />
                  </div>
                </div>
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {/* Package dialog */}
      {modalStatus === "reseller" && (
        <ResellerDialog {...{ show, setShow, isUpdate, reseller }} />
      )}

      {/* Reseller Invoice Dialog */}
      {modalStatus === "invoice" && (
        <ResellerInvoice {...{ show, setShow, reseller: resellerInfo }} />
      )}
    </>
  );
};

export default BandwidthReseller;
